import { Node_Type } from "./../../ricos-types/index.js";
import { TocRenderer } from "./toc.js";
const nodeViewRenderers = {
  [Node_Type.TOC]: TocRenderer
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
